module.exports = __webpack_public_path__ + "img/yaksa-yak-sa-pale-ale.aefcf535.png";